import { Injectable, inject } from '@angular/core';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class NavigationService {
  private readonly router = inject(Router);

  /**
   * Navigate to a route with optional scroll behavior
   * @param commands Navigation commands (same as router.navigate)
   * @param extras Navigation extras (same as router.navigate)
   * @param scrollToTop Whether to scroll to top after navigation (default: true)
   */
  navigate(commands: any[], extras?: any, scrollToTop = true): Promise<boolean> {
    const result = this.router.navigate(commands, extras);

    if (scrollToTop) {
      // Use setTimeout to ensure navigation is complete before scrolling
      setTimeout(() => {
        const mainLayout = document.querySelector('.main-layout');
        if (mainLayout) {
          mainLayout.scrollTo({ top: 0, behavior: 'smooth' });
        } else {
          window.scrollTo({ top: 0, behavior: 'smooth' });
        }
      }, 0);
    }

    return result;
  }

  /**
   * Navigate to a route without scrolling
   * @param commands Navigation commands (same as router.navigate)
   * @param extras Navigation extras (same as router.navigate)
   */
  navigateWithoutScroll(commands: any[], extras?: any): Promise<boolean> {
    return this.navigate(commands, extras, false);
  }
}
